import React, { useEffect, useState, useCallback } from 'react';
import styles from './description.module.scss';
import { actions } from '../../state/actions';
import { connect } from 'react-redux';
import {
  WithSpinner,
  TableProjects,
  TableRowProject,
  TableCellProject,
} from '../../components';

import { format } from 'date-fns';

const Projects = ({ projectList, dispatch, loading, canCreateRequest }) => {
  const tableHeader = ['Priemonė', 'Terminas', 'Kurti naują'];

  const currentDate = new Date();
  const fetchdata = useCallback(() => {
    dispatch(actions.dashboard.getProjectListAction());
  }, [dispatch, projectList]);

  useEffect(() => {
    dispatch(actions.dashboard.clearUserStateAction());
    fetchdata();
    dispatch(actions.dashboard.setSavedRequestDesissionAccepted(false));
    dispatch(actions.auth.pushTokenToServerAction());
  }, []);

  return (
    <WithSpinner loading={loading}>
      <div
        style={{
          marginTop: '1rem',
          marginBottom: '1rem',
          textAlign: 'center',
          marginLeft: '10%',
          marginRight: '10%',
        }}
      ></div>
      <div style={{ width: '50%', marginLeft: '20%' }}>
        <h2 style={{ marginTop: '50px' }}>Priemonių aprašymai</h2>

        <TableProjects
          header={tableHeader}
          isEmpty={false}
          style={{ background: '#000' }}
        >
          {projectList != null &&
            projectList.map(
              ({ Id, Title, StartDate, EndDate, DescriptionUrl }) => (
                <TableRowProject key={Id}>
                  <TableCellProject>
                    <h3>
                      {Id} {Title}
                    </h3>
                    <br />
                    Lorem ipsum dolor sit amet. Est nihil provident sit incidunt
                    harum eum inventore aliquid. Id ratione quod aut placeat
                    consequatur id maxime voluptatibus eos voluptas aliquam? Qui
                    possimus numquam qui omnis perferendis et excepturi
                    laudantium et laboriosam fugiat est distinctio sint!
                    <br />
                    <br />
                    <a href={DescriptionUrl}>{DescriptionUrl}</a>
                    <br /> <br /> Paraiškų teikimo terminas: nuo{' '}
                    <b>
                      {{ StartDate } !== null &&
                        format(new Date(StartDate), 'yyyy-MM-dd')}
                    </b>{' '}
                    iki{' '}
                    <b>
                      {EndDate !== null &&
                        format(new Date(EndDate), 'yyyy-MM-dd')}
                    </b>
                  </TableCellProject>
                </TableRowProject>
              )
            )}
        </TableProjects>
      </div>
    </WithSpinner>
  );
};

const mapStateToProps = (state) => ({
  projectList: state.dashboardState.projectList,
  loading: state.dashboardState.isOnSync,
});

export default connect(mapStateToProps)(Projects);
